module.exports = __webpack_public_path__ + "static/media/favicon.807b69db.ico";